import { type Program } from './programsData';

export const beautyWellnessProgramsData: Program = {
  id: "beauty-wellness",
  category: "Beauty & Wellness",
  focusArea: "Beauty therapy, spa treatments, wellness",
  description: "Transform lives through beauty and wellness. Our programs train students in professional beauty therapy, spa treatments, hair styling, and wellness management. Graduates are prepared for careers in salons, spas, wellness centers, and beauty industry.",
  color: "#00184dff",
  image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  levels: [
    {
      id: "beauty-wellness-cert-12th",
      level: "Certificate",
      eligibility: "12th",
      courses: [
        { id: "assistant-beauty-therapist-cert-12th", name: "Assistant Beauty Therapist", duration: "6", durationUnit: "Month", eligibility: "12th" },
        { id: "beauty-therapist-cert-12th", name: "Beauty Therapist", duration: "6", durationUnit: "Month", eligibility: "12th" },
        { id: "pedicurist-manicurist-cert-12th", name: "Pedicurist & Manicurist", duration: "6", durationUnit: "Month", eligibility: "12th" },
        { id: "nail-technician-cert-12th", name: "Nail Technician", duration: "6", durationUnit: "Month", eligibility: "12th" },
        { id: "hair-stylist-cert-12th", name: "Hair Stylist", duration: "6", durationUnit: "Month", eligibility: "12th" },
        { id: "assistant-spa-therapist-cert-12th", name: "Assistant Spa Therapist", duration: "6", durationUnit: "Month", eligibility: "12th" },
        { id: "spa-therapist-cert-12th", name: "Spa Therapist", duration: "6", durationUnit: "Month", eligibility: "12th" },
        { id: "make-up-artist-cert-12th", name: "Make-Up Artist", duration: "6", durationUnit: "Month", eligibility: "12th" },
        { id: "spa-wellness-management-cert-12th", name: "Spa & Wellness Management", duration: "6", durationUnit: "Month", eligibility: "12th" }
      ]
    },
    {
      id: "beauty-wellness-diploma-12th",
      level: "Diploma",
      eligibility: "12th",
      courses: [
        { id: "assistant-beauty-therapist-diploma-12th", name: "Assistant Beauty Therapist", duration: "1", durationUnit: "Year", eligibility: "12th" },
        { id: "beauty-therapist-diploma-12th", name: "Beauty Therapist", duration: "1", durationUnit: "Year", eligibility: "12th" },
        { id: "pedicurist-manicurist-diploma-12th", name: "Pedicurist & Manicurist", duration: "1", durationUnit: "Year", eligibility: "12th" },
        { id: "nail-technician-diploma-12th", name: "Nail Technician", duration: "1", durationUnit: "Year", eligibility: "12th" },
        { id: "hair-stylist-diploma-12th", name: "Hair Stylist", duration: "1", durationUnit: "Year", eligibility: "12th" },
        { id: "assistant-spa-therapist-diploma-12th", name: "Assistant Spa Therapist", duration: "1", durationUnit: "Year", eligibility: "12th" },
        { id: "spa-therapist-diploma-12th", name: "Spa Therapist", duration: "1", durationUnit: "Year", eligibility: "12th" },
        { id: "make-up-artist-diploma-12th", name: "Make-Up Artist", duration: "1", durationUnit: "Year", eligibility: "12th" },
        { id: "spa-wellness-management-diploma-12th", name: "Spa & Wellness Management", duration: "1", durationUnit: "Year", eligibility: "12th" }
      ]
    },
    {
      id: "beauty-wellness-cert-10th",
      level: "Certificate",
      eligibility: "10th",
      courses: [
        { id: "assistant-beauty-therapist-cert-10th", name: "Assistant Beauty Therapist", duration: "6", durationUnit: "Month", eligibility: "10th" },
        { id: "beauty-therapist-cert-10th", name: "Beauty Therapist", duration: "6", durationUnit: "Month", eligibility: "10th" },
        { id: "pedicurist-manicurist-cert-10th", name: "Pedicurist & Manicurist", duration: "6", durationUnit: "Month", eligibility: "10th" },
        { id: "nail-technician-cert-10th", name: "Nail Technician", duration: "6", durationUnit: "Month", eligibility: "10th" },
        { id: "hair-stylist-cert-10th", name: "Hair Stylist", duration: "6", durationUnit: "Month", eligibility: "10th" },
        { id: "assistant-spa-therapist-cert-10th", name: "Assistant Spa Therapist", duration: "6", durationUnit: "Month", eligibility: "10th" },
        { id: "spa-therapist-cert-10th", name: "Spa Therapist", duration: "6", durationUnit: "Month", eligibility: "10th" },
        { id: "make-up-artist-cert-10th", name: "Make-Up Artist", duration: "6", durationUnit: "Month", eligibility: "10th" },
        { id: "spa-wellness-management-cert-10th", name: "Spa & Wellness Management", duration: "6", durationUnit: "Month", eligibility: "10th" }
      ]
    },
    {
      id: "beauty-wellness-diploma-10th",
      level: "Diploma",
      eligibility: "10th",
      courses: [
        { id: "assistant-beauty-therapist-diploma-10th", name: "Assistant Beauty Therapist", duration: "1", durationUnit: "Year", eligibility: "10th" },
        { id: "beauty-therapist-diploma-10th", name: "Beauty Therapist", duration: "1", durationUnit: "Year", eligibility: "10th" },
        { id: "pedicurist-manicurist-diploma-10th", name: "Pedicurist & Manicurist", duration: "1", durationUnit: "Year", eligibility: "10th" },
        { id: "nail-technician-diploma-10th", name: "Nail Technician", duration: "1", durationUnit: "Year", eligibility: "10th" },
        { id: "hair-stylist-diploma-10th", name: "Hair Stylist", duration: "1", durationUnit: "Year", eligibility: "10th" },
        { id: "assistant-spa-therapist-diploma-10th", name: "Assistant Spa Therapist", duration: "1", durationUnit: "Year", eligibility: "10th" },
        { id: "spa-therapist-diploma-10th", name: "Spa Therapist", duration: "1", durationUnit: "Year", eligibility: "10th" },
        { id: "make-up-artist-diploma-10th", name: "Make-Up Artist", duration: "1", durationUnit: "Year", eligibility: "10th" },
        { id: "spa-wellness-management-diploma-10th", name: "Spa & Wellness Management", duration: "1", durationUnit: "Year", eligibility: "10th" }
      ]
    }
  ]
};
